import { useParams } from "react-router-dom";

export type FarmerType = "dairy" | "meat" | "default";

export const useGetFarmerType = (): FarmerType => {
  const { type } = useParams<{ type?: string }>();

  if (type === "dairy") {
    return "dairy";
  }

  if (type === "meat") {
    return "meat";
  }

  return "default";
};
